import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';

const SET_PAGINATION = '_SET_PAGINATION';

export const setPaginationFor = (prefix) => {
  const setPagination = (response) => {
    const { headers } = response;
    return {
      type: prefix + SET_PAGINATION,
      payload: {
        page: parseInt(headers['x-page'], 10),
        perPage: parseInt(headers['x-per-page'], 10),
        total: parseInt(headers['x-total'], 10),
      }
    }
  };
  return setPagination;
};

const initialState = fromJS({
  page: 1,
  perPage: 25,
  total: 0,
});

export const paginationReducerFor = (prefix) => {
  return handleActions({
    [prefix+SET_PAGINATION]: (state, { payload }) => {
      return state.merge(payload);
    }
  }, initialState);
};



// WEBPACK FOOTER //
// ./src/store/pagination-reducer.js